import Mock from 'mockjs'

Mock.mock('/base/Monitor/gatedata', {
        topBar:{
            "weather":"天气：晴",
            "title":"哈密算力中心实时数据"
        },
        mouthdataProfiling:{
            "usageRate": "55.55",
            "computationTotal": "1347",
            "energyConsumption": "2386"
        },
        mouthdataProList: [
            {
                "name": "智算算力",
                "cont": "执行作业111次",
                "chartName": "智算算力",
                "data": "20"
            },
            {
                "name": "超算算力",
                "cont": "执行作业222次",
                "chartName": "超算算力",
                "data": "55"
            },
            {
                "name": "通用算力",
                "cont": "执行作业333次",
                "chartName": "通用算力",
                "data": "82.11"
            }
        ],
        computingUse:[
            {
            "name": "电信",
            "value": "14.10"
            }, {
                "name": "互联网",
                "value": "13.70"
            }, {
                "name": "教育",
                "value": "26.20"
            }, {
                "name": "能源",
                "value": "5.90"
            }, {
                "name": "生物",
                "value": "14.40"
            }, {
                "name": "工业制造",
                "value": "21.20"
            }, {
                "name": "其他",
                "value": "5.50"
            }
        ],
        energyTrend:{
            "labels": ["1-1", "1-2", "1-3", "1-4", "1-5", "1-6", "1-7", "1-8", "1-9", "1-10"],
            "series": [{
                "name": "智算",
                "data": [0, 10, 50, 110, 150, 200, 250, 300, 310, 350, 400],
                "color": "#04A7F3"
            }, {
                "name": "超算",
                "data": [100, 200, 300, 400, 300, 200, 100, 0, 100, 200],
                "color": "#38C171"
            }, {
                "name": "通用",
                "data": [145, 121, 211, 231, 208, 315, 300, 400, 200, 100],
                "color": "#E7C42C"
            }]
        },
        contentMain:{
            "machineRoom": 5,
            "bodyFrame": 13,
            "device": 220,
            "totalPower": 204
        },
        contentMainCenter:{
            "witserver":"8台 13 PFLOPS",
            "currencyserver":"100台",
            "superserver":"80台 231 PFLOPS",
            "networkserver":"23台/300"
        },
        contentMainNews:[
            {
                "data":"12-12 9:00-10:30",
                "title":"数据中心集群服务器",
                "content":"芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决解决…"
            },
            {
                "data":"12-13 9:00-10:30",
                "title":"数据中心集群服务器",
                "content":"芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决解决…"
            },
            {
                "data":"12-14 9:00-10:30",
                "title":"数据中心集群服务器",
                "content":"芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决解决…"
            },
            {
                "data":"12-15 9:00-10:30",
                "title":"数据中心集群服务器",
                "content":"芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决方案芯片产品解决解决…"
            }
        ],
        computingRatioCpu:[
            {
            "name": "AMD",
            "value": "15"
            }, {
                "name": "鲲鹏",
                "value": "22"
            }, {
                "name": "海光",
                "value": "18"
            }, {
                "name": "飞腾",
                "value": "12"
            }, {
                "name": "Intel",
                "value": "33"
            }
        ],
        computingRatioGpu:[
            {
                "name": "H800：",
                "value": 75
            }, {
                "name": "4090：",
                "value": 15
            },
            {
                "name": "昇腾：",
                "value": 10
            }
        ],
        
})
